import Color from 'color';
export const blendColors = colors => {
  if (colors.length === 0) {
    return new Color().alpha(0);
  }
  if (colors.length === 1) {
    return colors[0];
  }
  let color = colors[0];
  colors.slice(1).forEach(current => {
    const [r1, g1, b1, a1] = colorToRgbaArray(color);
    const [r2, g2, b2, a2] = colorToRgbaArray(current);
    const a = a1 + a2 * (1 - a1);
    const r = (r1 * a1 + r2 * a2 * (1 - a1)) / a || 0;
    const g = (g1 * a1 + g2 * a2 * (1 - a1)) / a || 0;
    const b = (b1 * a1 + b2 * a2 * (1 - a1)) / a || 0;
    color = Color({
      alpha: a,
      b,
      g,
      r
    });
  });
  return color;
};
const colorToRgbaArray = color => [color.red(), color.green(), color.blue(), color.alpha()];
//# sourceMappingURL=blend-colors.js.map